export default "__VITE_ASSET__CjoAaaqn__"